import React, { useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom"; // Use useNavigate for v6
import { forgotPassword } from "../../apis/apisList/userApi";
import { toast } from "react-toastify";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({ email: "" });
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate(); // Initialize navigate for navigation

  const validateForm = () => {
    const newErrors = {};
    if (!email) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Invalid email address.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (validateForm()) {
      try {
        const emailLower = email.toLowerCase();
        // Make the API call to request a password reset
        await forgotPassword({ email: emailLower });
        localStorage.setItem("temp_user", emailLower);
        toast.success("OTP has been sent to your email.");
        navigate("/reset-password"); // Redirect to password reset page
        setErrors({ email: "" }); // Clear any previous errors
      } catch (error) {
        const message =
          error.response.data.message ||
          "Something went wrong. Please try again.";
        console.error("Error during password reset request:", error);
        // Handle network or server error
        setErrors({ email: message });
      }
    }
  };

  const login_style = {
    title: {
      fontSize: "24px",
      fontWeight: "600",
    },
    loginBtn: {
      backgroundColor: "#065F9C",
      boxShadow: "none",
      borderRadius: "10px",
      padding: "12px 20px",
      fontSize: "20px",
      fontWeight: "500",
      textTransform: "inherit",
    },
  };

  return (
    <Box sx={{ width: "100%", maxWidth: "355px", margin: "0 auto" }}>
      <Typography
        style={login_style.title}
        variant="h6"
        align="center"
        sx={{ marginBottom: 4, paddingBottom: 2, borderBottom: 2 }}
      >
        Forgot Password
      </Typography>
      <Typography
        variant="body1"
        align="center"
        sx={{ marginBottom: 3, color: "#666" }}
      >
        Enter your email address, and we'll send you a link to reset your
        password.
      </Typography>
      <TextField
        label="Email"
        variant="outlined"
        fullWidth
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
          setErrors({ ...errors, email: "" }); // Clear the error message
        }}
        error={!!errors.email} // Display error state
        helperText={errors.email} // Display error message
        sx={{
          marginBottom: 3,
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px", // Apply borderRadius here
          },
        }}
      />
      {successMessage && (
        <Typography
          variant="body1"
          align="center"
          sx={{ marginBottom: 3, color: "green" }}
        >
          {successMessage}
        </Typography>
      )}
      <Button
        style={login_style.loginBtn}
        variant="contained"
        fullWidth
        onClick={handleSubmit}
        sx={{ marginBottom: 0 }}
      >
        Submit
      </Button>
      <Button
        fullWidth
        onClick={() => navigate("/login")} // Redirect to the login page
        sx={{ marginTop: 2, textTransform: "inherit", color: "#065F9C" }}
      >
        Back to Login
      </Button>
    </Box>
  );
};

export default ForgotPassword;
